import { meetsAccessibilityStandards } from "@/lib/color-utils";
import { AlertTriangle, PaletteIcon } from "lucide-react";

interface TierPreviewProps {
  labelColor: string;
  backgroundColor: string;
  onClick?: () => void;
}

export function TierPreview({
  labelColor,
  backgroundColor,
  onClick,
}: TierPreviewProps) {
  const hasAccessibilityIssue = !meetsAccessibilityStandards(
    labelColor,
    backgroundColor
  );

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={!onClick}
      className="size-9 flex items-center justify-center border border-solid rounded-md relative shrink-0 hover:opacity-80 transition-opacity duration-150 disabled:cursor-default disabled:hover:opacity-100"
      style={{
        borderColor: backgroundColor,
      }}
    >
      <div
        className="size-6 rounded-md flex items-center justify-center"
        style={{
          backgroundColor: backgroundColor,
        }}
      >
        <PaletteIcon className="size-4" style={{ color: labelColor }} />
      </div>
      {hasAccessibilityIssue && (
        <div
          className="absolute top-0 right-0 -translate-y-1/2 translate-x-1/2 bg-yellow-500 rounded-full p-1"
          title="Low contrast - may not meet accessibility standards"
        >
          <AlertTriangle className="w-3 h-3 text-black" />
        </div>
      )}
    </button>
  );
}
